import { get, includes, isArray, intersection } from 'lodash'

export default {
  auth: false,
  user: null,
  default_user: null,
  recentViews: [],
  entities: [],
  languages: [],
  currencies: [],
  cms_upload: {},
  heartbeatTimeoutHandle: null,

  checkAccess (params) {
    if (!params || !params.value || !params.key) {
      return true
    }
    if (this.auth === false) {
      return false
    }

    let value = get(this.user.permission, params.key, false)

    return isArray(value) ? includes(value, params.value) || intersection(value, params.value).length > 0 : (value === params.value || value === true)
  },

  checkVerification () {
    return get(this.user, 'settings.verified.email') && get(this.user, 'settings.verified.phone')
  }

}
